import React from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useSaidasSuprimentos } from "./servicosData";

const SuprimentosSaidas: React.FC = () => {
  const headers = [
    "OS",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Técnico",
    "C. Responsável",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useSaidasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "70px", // Código
    "300px", // Nome do Produto
    "50px", // Quantidade
    "90px", // Custo Unitário
    "90px", // Técnico
    "140px", // C. Responsável
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Baixas Serviços"
        // buttons={[
        //   {
        //     label: "Gerar Relatório",
        //     onClick: () => console.log("Relatório gerado"),
        //     variant: "secondary",
        //   },
        // ]}
      />
      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        isTableStandby
      />
    </div>
  );
};

export default SuprimentosSaidas;
